import { fromBulkUploadItemResponse } from '../models/mapper'
import { BulkUploadItemsResult } from '../models/types'
import { bulkUploadItemsCsvV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function bulkUploadItemsCsv(consignmentId: number, formData: FormData): Promise<BulkUploadItemsResult> {
  const response = await bulkUploadItemsCsvV3(consignmentId, formData)
  return fromBulkUploadItemResponse(response)
}
